import { Min } from "@pdfking/math"
import type { PageShape } from "@pdfking/renderer-api"
import { PlotFunction } from "@pdfking/renderer-api"
import { GrowContentKind } from "@pdfking/templates"

import { PALETTE } from "#constants"

import { DrawBoxWall } from "../box/DrawBoxWall"
import { DrawFrontCover } from "../cover/DrawFrontCover"
import type { Composition } from "./Composition"
import { ComposePieces, Ground } from "./Composition"

/** A product's box made of its pieces: on the outside the face showing page
 * 1 is the front, title and picture on it as a book's cover has them, every
 * other page a wall with a heading and a few lines about the product — too
 * narrow for one, the primary alone —, a spine or a flap the primary. The
 * inside is the pattern, the pieces mirrored along the opening, bare. */
export const BoxContent = (c: Composition): PageShape[] => {
  const { is_front, measure, seed, short } = c
  const primary = (box: Parameters<typeof DrawBoxWall>[0]["box"]): PageShape[] =>
    is_front ? [{ enum: PlotFunction.PLOT_RECT, fill_color: PALETTE.primary, position: box }] : []
  return [
    ...Ground(c),
    ...ComposePieces(c, {
      [GrowContentKind.FLAP]: ({ box }) => primary(box),
      [GrowContentKind.PAGE]: ({ box, index, piece, reach, security }) => {
        if (!is_front) return []
        if (piece.page_front === 1 || piece.page_rear === 1)
          return DrawFrontCover({ bleed: reach, box, measure, security, seed })
        if (Min(box.width, box.height) < short / 4) return primary(box)
        return DrawBoxWall({ box, index, measure, security, seed })
      },
      [GrowContentKind.SPINE]: ({ box }) => primary(box),
    }),
  ]
}
